export const formatLocaleNumber = (
  value: number | null | undefined,
  decimals?: number,
): string => {
  if (value === null || value === undefined) return '-';
  return value.toLocaleString('en-AU', {
    minimumFractionDigits: decimals ?? 0,
    maximumFractionDigits: decimals ?? 0,
  });
};

export const formatPercent = (
  value: number | null | undefined,
  decimals = 2,
): string => {
  if (value === null || value === undefined) return '-';
  const sign = value > 0 ? '+' : '';
  return `${sign}${formatLocaleNumber(value, decimals)}%`;
};

// Abbreviates large values (e.g. TNA) to millions, e.g. 25,517,900,000 -> "25,517.90M".
export const formatMillions = (
  value: number | null | undefined,
  decimals = 2,
): string => {
  if (value === null || value === undefined) return '-';
  return `${formatLocaleNumber(value / 1_000_000, decimals)}M`;
};

export const formatYears = (
  value: number | string | null | undefined,
): string => {
  if (value === null || value === undefined || value === '') return '-';
  const num = Number(value);
  if (num < 1) return '< 1';
  return String(value);
};

export const formatFundMilionValues = (
  value: number | string | null | undefined,
  dp?: number,
): string => {
  if (value == null || (typeof value === 'string' && value.trim() === ''))
    return '-';
  const num =
    typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value;
  if (!Number.isFinite(num)) return '-';
  const millionValue = num / 1000000;
  return `${formatLocaleNumber(millionValue, dp ?? 3)}`;
};

export const removeCommaNumber = (num: string | number) => {
  return String(num).replaceAll(',', '');
};

export const addPrefixNumber = (data: string | number | null | undefined) => {
  if (
    (typeof data === 'number' && data > 0) ||
    (typeof data === 'string' &&
      typeof parseFloat(removeCommaNumber(data)) === 'number' &&
      parseFloat(data) > 0)
  ) {
    return `+${data}`;
  }
  return data;
};
